import { useEffect, useState } from 'react';

export const AUDIO_EYE_LAUNCHER_SELECTOR = '#ae_launcher button';

const AUDIOEYE_READY_ATTR = 'data-audioeye-launcher';
const OBSERVER_TIMEOUT = 10000;

export const useIsAudioEyeReady = (enabled: boolean): boolean => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsReady(false);

      return undefined;
    }

    if (document.body.hasAttribute(AUDIOEYE_READY_ATTR)) {
      setIsReady(true);

      return undefined;
    }

    let timeout: ReturnType<typeof setTimeout>;

    const observer = new MutationObserver(() => {
      setIsReady(true);
      observer.disconnect();
      clearTimeout(timeout);
    });

    timeout = setTimeout(() => {
      observer.disconnect();
    }, OBSERVER_TIMEOUT);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [AUDIOEYE_READY_ATTR],
    });

    return () => {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, [enabled]);

  return isReady;
};
